export default {
  data() {
    return {
      contactsDropdownData: {
        mobileDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortContacts(
                    this.teamsSettings[this.$route.params.team].listsSettings.contacts.order.col,
                    "ASC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortContacts(
                    this.teamsSettings[this.$route.params.team].listsSettings.contacts.order.col,
                    "DESC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
          {
            title: this.$t("dropdowns.sortingBy"),
            options: [
              {
                label: this.$t("contact.name"),
                key: "last_name",
                method: () => {
                  this.sortContacts(
                    "last_name",
                    this.teamsSettings[this.$route.params.team].listsSettings.contacts.order.dir
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.email"),
                key: "email",
                method: () => {
                  this.sortContacts(
                    "email",
                    this.teamsSettings[this.$route.params.team].listsSettings.contacts.order.dir
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.updated_at"),
                key: "updated_at",
                method: () => {
                  this.sortContacts(
                    "updated_at",
                    this.teamsSettings[this.$route.params.team].listsSettings.contacts.order.dir
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.created_at"),
                key: "created_at",
                method: () => {
                  this.sortContacts(
                    "created_at",
                    this.teamsSettings[this.$route.params.team].listsSettings.contacts.order.dir
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
        sortMainColDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            key: "last_name",
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortContacts("last_name", "ASC");
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortContacts("last_name", "DESC");
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
        showAsFirstColDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            disabled: false,
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortContacts(
                    this.teamsSettings[this.$route.params.team].listsSettings.contacts.showAs.firstCol.key,
                    "ASC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
                disabled: false,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortContacts(
                    this.teamsSettings[this.$route.params.team].listsSettings.contacts.showAs.firstCol.key,
                    "DESC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
                disabled: false,
              },
            ],
          },
          {
            title: this.$t("dropdowns.showAs"),
            options: [
              {
                label: this.$t("contact.street"),
                key: "street",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      firstCol: {
                        label: "contact.street",
                        key: "street",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.zip"),
                key: "zip",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      firstCol: {
                        label: "contact.zip",
                        key: "zip",
                        format: "none",
                        size: 1,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.city"),
                key: "city",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      firstCol: {
                        label: "contact.city",
                        key: "city",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.country"),
                key: "country",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      firstCol: {
                        label: "contact.country",
                        key: "country",
                        format: "country",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.company"),
                key: "company",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      firstCol: {
                        label: "contact.company",
                        key: "company",
                        format: "none",
                        size: 2,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.email"),
                key: "email",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      firstCol: {
                        label: "contact.email",
                        key: "email",
                        format: "none",
                        size: 2,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.tel"),
                key: "tel",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      firstCol: {
                        label: "contact.tel",
                        key: "tel",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.fax"),
                key: "fax",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      firstCol: {
                        label: "contact.fax",
                        key: "fax",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.mobile"),
                key: "mobile",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      firstCol: {
                        label: "contact.mobile",
                        key: "mobile",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.website"),
                key: "website",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      firstCol: {
                        label: "contact.website",
                        key: "website",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.gender"),
                key: "gender",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      firstCol: {
                        label: "contact.gender",
                        key: "gender",
                        format: "gender",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.jobTitle"),
                key: "job_title",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      firstCol: {
                        label: "contact.jobTitle",
                        key: "job_title",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.jobUnit"),
                key: "job_unit",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      firstCol: {
                        label: "contact.jobUnit",
                        key: "job_unit",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.timezone"),
                key: "timezone",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      firstCol: {
                        label: "contact.timezone",
                        key: "timezone",
                        format: "timezone",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.updated_at"),
                key: "updated_at",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      firstCol: {
                        label: "contact.updated_at",
                        key: "updated_at",
                        format: "date",
                        size: 2,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.created_at"),
                key: "created_at",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      firstCol: {
                        label: "contact.created_at",
                        key: "created_at",
                        format: "date",
                        size: 2,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
        showAsSecondColDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            disabled: false,
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortContacts(
                    this.teamsSettings[this.$route.params.team].listsSettings.contacts.showAs.secondCol.key,
                    "ASC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
                disabled: false,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortContacts(
                    this.teamsSettings[this.$route.params.team].listsSettings.contacts.showAs.secondCol.key,
                    "DESC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
                disabled: false,
              },
            ],
          },
          {
            title: this.$t("dropdowns.showAs"),
            options: [
              {
                label: this.$t("contact.street"),
                key: "street",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      secondCol: {
                        label: "contact.street",
                        key: "street",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.zip"),
                key: "zip",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      secondCol: {
                        label: "contact.zip",
                        key: "zip",
                        format: "none",
                        size: 1,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.city"),
                key: "city",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      secondCol: {
                        label: "contact.city",
                        key: "city",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.country"),
                key: "country",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      secondCol: {
                        label: "contact.country",
                        key: "country",
                        format: "country",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.company"),
                key: "company",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      secondCol: {
                        label: "contact.company",
                        key: "company",
                        format: "none",
                        size: 2,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.email"),
                key: "email",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      secondCol: {
                        label: "contact.email",
                        key: "email",
                        format: "none",
                        size: 2,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.tel"),
                key: "tel",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      secondCol: {
                        label: "contact.tel",
                        key: "tel",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.fax"),
                key: "fax",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      secondCol: {
                        label: "contact.fax",
                        key: "fax",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.mobile"),
                key: "mobile",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      secondCol: {
                        label: "contact.mobile",
                        key: "mobile",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.website"),
                key: "website",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      secondCol: {
                        label: "contact.website",
                        key: "website",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.gender"),
                key: "gender",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      secondCol: {
                        label: "contact.gender",
                        key: "gender",
                        format: "gender",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.jobTitle"),
                key: "job_title",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      secondCol: {
                        label: "contact.jobTitle",
                        key: "job_title",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.jobUnit"),
                key: "job_unit",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      secondCol: {
                        label: "contact.jobUnit",
                        key: "job_unit",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.timezone"),
                key: "timezone",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      secondCol: {
                        label: "contact.timezone",
                        key: "timezone",
                        format: "timezone",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.updated_at"),
                key: "updated_at",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      secondCol: {
                        label: "contact.updated_at",
                        key: "updated_at",
                        format: "date",
                        size: 2,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.created_at"),
                key: "created_at",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      secondCol: {
                        label: "contact.created_at",
                        key: "created_at",
                        format: "date",
                        size: 2,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
        showAsThirdColDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            disabled: false,
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortContacts(
                    this.teamsSettings[this.$route.params.team].listsSettings.contacts.showAs.thirdCol.key,
                    "ASC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
                disabled: false,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortContacts(
                    this.teamsSettings[this.$route.params.team].listsSettings.contacts.showAs.thirdCol.key,
                    "DESC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
                disabled: false,
              },
            ],
          },
          {
            title: this.$t("dropdowns.showAs"),
            options: [
              {
                label: this.$t("contact.street"),
                key: "street",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      thirdCol: {
                        label: "contact.street",
                        key: "street",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.zip"),
                key: "zip",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      thirdCol: {
                        label: "contact.zip",
                        key: "zip",
                        format: "none",
                        size: 1,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.city"),
                key: "city",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      thirdCol: {
                        label: "contact.city",
                        key: "city",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.country"),
                key: "country",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      thirdCol: {
                        label: "contact.country",
                        key: "country",
                        format: "country",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.company"),
                key: "company",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      thirdCol: {
                        label: "contact.company",
                        key: "company",
                        format: "none",
                        size: 2,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.email"),
                key: "email",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      thirdCol: {
                        label: "contact.email",
                        key: "email",
                        format: "none",
                        size: 2,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.tel"),
                key: "tel",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      thirdCol: {
                        label: "contact.tel",
                        key: "tel",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.fax"),
                key: "fax",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      thirdCol: {
                        label: "contact.fax",
                        key: "fax",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.mobile"),
                key: "mobile",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      thirdCol: {
                        label: "contact.mobile",
                        key: "mobile",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.website"),
                key: "website",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      thirdCol: {
                        label: "contact.website",
                        key: "website",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.gender"),
                key: "gender",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      thirdCol: {
                        label: "contact.gender",
                        key: "gender",
                        format: "gender",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.jobTitle"),
                key: "job_title",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      thirdCol: {
                        label: "contact.jobTitle",
                        key: "job_title",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.jobUnit"),
                key: "job_unit",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      thirdCol: {
                        label: "contact.jobUnit",
                        key: "job_unit",
                        format: "none",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.timezone"),
                key: "timezone",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      thirdCol: {
                        label: "contact.timezone",
                        key: "timezone",
                        format: "timezone",
                        size: 2,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.updated_at"),
                key: "updated_at",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      thirdCol: {
                        label: "contact.updated_at",
                        key: "updated_at",
                        format: "date",
                        size: 2,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("contact.created_at"),
                key: "created_at",
                method: () => {
                  this.changeCol({
                    list: "contacts",
                    showAs: {
                      thirdCol: {
                        label: "contact.created_at",
                        key: "created_at",
                        format: "date",
                        size: 2,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
        filterDropdown: [
          {
            title: this.$t("filters.filterClients"),
            options: [
              // {
              //       label: this.$t('filters.myClients'),
              //       switch: {
              //         name: 'is_mine',
              //         model: true
              //       },
              //       checkbox: true,
              //       method: () => {},
              //       hoverBg: true
              //     },
              //     {
              //       label: this.$t('filters.withTags'),
              //       select: {
              //         name: 'with_tag',
              //         multiple: true,
              //         model: [],
              //         options: [],
              //         label: 'label',
              //         placeholder: this.$t('placeholders.selectTag'),
              //         wrap: true,
              //         searchable: true,
              //         searchChange: this.loadTags
              //       },
              //       method: () => {},
              //       checkbox: true,
              //       hoverBg: true,
              //       hideIfNoOptions: true
              //     },
              //     {
              //       label: this.$t('filters.withoutTags'),
              //       select: {
              //         name: 'without_tag',
              //         multiple: true,
              //         model: [],
              //         options: [],
              //         label: 'label',
              //         placeholder: this.$t('placeholders.selectTag'),
              //         wrap: true,
              //         searchable: true,
              //         searchChange: this.loadTags
              //       },
              //       method: () => {},
              //       checkbox: true,
              //       hoverBg: true,
              //       hideIfNoOptions: true
              //     },
              //     {
              //       label: this.$t('filters.activateFilter'),
              //       border: 'border-top',
              //       color: 'primary',
              //       position: 'center',
              //       method: () => { this.setClientsFilters() },
              //       noActiveState: true,
              //       button: true
              //     },
              //     {
              //       label: this.$t('filters.resetFilter'),
              //       color: 'text-danger',
              //       position: 'center',
              //       method: () => { this.resetFilters(this.setClientsFilters) },
              //       hoverBg: true,
              //       noActiveState: true
              //     }
            ],
          },
        ],
      },
    };
  },
};
